/**
 * ApplicationToast Redux Integration
 * 
 * This module provides Redux action types and action creators for managing toast notifications
 * using the ApplicationToast wrapper component.
 */

// Toast Action Types
export const TOAST_ACTION_TYPES = {
  ADD_TOAST: 'TOAST.ADD',
  REMOVE_TOAST: 'TOAST.REMOVE',
  CLEAR_TOASTS: 'TOAST.CLEAR'
};

// Toast Action Creators
export const toastActions = {
  /**
   * Add a new toast notification
   * @param {string} id - Unique identifier for the toast
   * @param {string} title - Toast title
   * @param {string} message - Toast message/details
   * @param {string} type - Toast type: 'success', 'error', 'warning', 'info'
   * @param {string} scope - Optional scope for filtering toasts
   */
  addToast: (id, title, message, type = 'info', scope = null) => ({
    type: TOAST_ACTION_TYPES.ADD_TOAST,
    payload: {
      id,
      title,
      message,
      type,
      scope,
      timestamp: Date.now()
    }
  }),

  /**
   * Remove a specific toast by ID
   * @param {string} id - Toast ID to remove
   */
  removeToast: (id) => ({
    type: TOAST_ACTION_TYPES.REMOVE_TOAST,
    payload: { id }
  }),

  /**
   * Clear all toasts (optionally filtered by scope)
   * @param {string} scope - Optional scope to clear
   */
  clearToasts: (scope = null) => ({
    type: TOAST_ACTION_TYPES.CLEAR_TOASTS,
    payload: { scope }
  })
};

